import type {DataRouterBlamePayload} from '@github-ui/code-view-types'
import {repositoryTreePath} from '@github-ui/paths'
import type {DataRouterApplicationBuilder} from '@github-ui/react-core/future/data-router-application'
import {QueryRouteQueryType} from '@github-ui/react-core/future/data-router-types'
import {mainQuery} from '@github-ui/react-core/future/main-query'
import {queryFnFetch} from '@github-ui/react-core/future/query-fn-fetch'
import type {ContributorsInfo} from '@github-ui/repos-types'

import {codeViewAppBuilder} from '../config/app-builder'

export function buildCodeViewBlameRoute(appBuilder: DataRouterApplicationBuilder<string>) {
  return appBuilder.createQueryRouteConfig('codeViewBlameRoute', {
    path: '/:owner/:repo/blame/:branch/*',
    queries: [
      mainQuery<DataRouterBlamePayload>({encodeFetchPath: true}),
      {
        queryName: 'contributors',
        queryDeps: ({params}) => {
          return {
            pathname: repositoryTreePath({
              repo: {
                ownerLogin: params.owner,
                name: params.repo,
              },
              commitish: params.branch,
              path: params['*'] || '',
              action: 'file-contributors',
            }),
          }
        },
        queryFn: async queryKey => queryFnFetch<ContributorsInfo>(queryKey),
        type: QueryRouteQueryType.Deferred,
      },
    ],
  })
}

export const codeViewBlameRoute = buildCodeViewBlameRoute(codeViewAppBuilder)
